import React, { useMemo } from 'react';
import Footer from '@ajat/design-system/Footer';
import useMenuItemNavigation from '../../../../hooks/useMenuItemNavigation';
import useMenuItemVisibility from '../../../../hooks/useMenuItemVisibility';

/* ══════════════════════════════════════════════════════════════════════════
 * CLS-FI — Common Footer
 * Single source of truth for footer configuration across all CLS-FI pages
 * Navigation column mirrors the Header navItems
 * ══════════════════════════════════════════════════════════════════════════ */

// Columns are built per instance so "Haalarit & muut" / "Vaatteet" resolve to
// the customer's mapped school shop (or open the selector) like the Header.
const buildColumns = (onMenuItemClick) => [
  {
    title: 'TARVITSETKO APUA?',
    links: [
      { label: 'Kokotaulukko', href: '/clothing/cls-fi/size-guide' },
      { label: 'FAQ', href: '/clothing/cls-fi/faq' },
      { label: 'Ota yhteyttä', href: '/clothing/cls-fi/contact' },
      // Reklamaatio hidden — restore together with the claims route + helpConfig entries.
      // { label: 'Reklamaatio', href: '/clothing/cls-fi/claims' },
    ],
  },
  {
    title: 'C.L. SEIFERT',
    links: [
      { label: 'Haalarit & muut', menuKey: 'menu_1', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_1'); } },
      { label: 'Vaatteet', menuKey: 'menu_2', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_2'); } },
      { label: 'Oheistuotteet', href: '/clothing/cls-fi/accessories' },
      { label: 'Suunnittele ylioppilaslakki', href: 'https://clseifert.com/fi/wizard' },
      { label: 'Tilaa sovitussetti', href: 'https://clseifert.com/fi/tilaa-sovitussetti' },
      { label: 'Koulun yhteistilaus', href: 'https://clseifert.com/fi/koulun-yhteistilaus' },
    ],
  },
];

const legalLinks = [
  { label: 'Kauppaehdot', href: '/clothing/cls-fi/terms' },
  { label: 'Tietosuojakäytäntö', href: '/clothing/cls-fi/privacy' },
];

// FI-TODO: no Finnish social accounts yet — hidden rather than pointing at the DK ones.
const socials = [];

const contact = {
  title: 'OTA YHTEYTTÄ',
  email: { label: 'info@clseifert.fi', href: 'mailto:info@clseifert.fi' },
  address: ['Kalevankatu 30,', '00100 Helsinki'],
};

export const copyright = `© ${new Date().getFullYear()} C.L. Seifert Finland Oy. Kaikki oikeudet pidätetään.`;

const CLSFIFooter = (props) => {
  const onMenuItemClick = useMenuItemNavigation({ brandSlug: 'clsfi', feSlug: 'cls-fi' });
  // Same visibility rule as the header menu items ("Disable Open Shop"):
  // menuKey-tagged footer links hide when that shop type isn't available.
  const { isVisible } = useMenuItemVisibility('clsfi');
  const columns = useMemo(
    () => buildColumns(onMenuItemClick).map((col) => ({
      ...col,
      links: col.links.filter((l) => !l.menuKey || isVisible(l.menuKey)),
    })),
    [onMenuItemClick, isVisible],
  );

  return (
    <Footer brand="CLS" columns={columns} legalLinks={legalLinks} socials={socials} contact={contact} copyright={copyright} {...props} />
  );
};

export default CLSFIFooter;
